// component
import Faq from "@/components/faq/Faq";
import SEO from "@/components/seo/SEO";

// API
import { API, graphqlOperation, withSSRContext } from "aws-amplify";
import { getFaqList } from "@/graphql/queries";

// rest api
import { getMerchantData } from "./api/merchant";

import { getDomainForSSR } from "@/utils/util";

const FaqScreen = (props) => {
  return (
    <>
      <SEO title="FAQ" keywords="" description="FAQ" />
      <Faq faqList={props.faqList ? props.faqList : []} />
    </>
  );
};

export default FaqScreen;

// get faq info
export async function getServerSideProps(context) {
  const { domain, shopId } = getDomainForSSR(context);
  let merchantId = "";
  if (shopId) {
    if (context.req.cookies[`${shopId}@merchantId`]) {
      merchantId = context.req.cookies[`${shopId}@merchantId`];
    } else {
      const merchantJsonData = await getMerchantData(domain);
      merchantId = merchantJsonData.merchantId;
    }
  } else {
    return { notFound: true };
  }

  try {
    const params = {
      merchantId: merchantId,
    };
    const SSR = withSSRContext();
    const res = await API.graphql(graphqlOperation(getFaqList, params));
    if (res.data.getFaqList.status) {
      return {
        props: {
          faqList: res.data.getFaqList,
        },
      };
    } else {
      return { notFound: true };
    }
  } catch (error) {
    return { notFound: true };
  }
}
